import { fmtPct, tone, slug } from "@/lib/format";
import { LtpCell } from "./LtpCell";
import { StatusBadge } from "./StatusBadge";

export const IndicesStrip = ({ rows, onOpen }) => (
  <section data-testid="indices-strip" className="scroll-thin -mx-1 flex gap-2 overflow-x-auto px-1 pb-1">
    {(rows || []).map((r, i) => (
      <button
        key={r.instrument_token}
        data-testid={`index-card-${slug(r.tradingsymbol)}`}
        onClick={() => onOpen(r)}
        style={{ animationDelay: `${i * 30}ms` }}
        className="rise group min-w-[170px] shrink-0 rounded-md border border-slate-800 bg-[#111827] px-3 py-2.5 text-left transition-colors hover:border-cyan-700/60"
      >
        <div className="flex items-center justify-between gap-2">
          <span className="truncate text-[11px] font-semibold uppercase tracking-wider text-slate-400 group-hover:text-slate-200">
            {r.tradingsymbol}
          </span>
          <span className="font-mono text-[9px] text-slate-600">{r.exchange}</span>
        </div>
        <div className="mt-1 flex items-baseline justify-between gap-2">
          <LtpCell value={r.ltp} className="text-base font-semibold text-slate-100" />
          <span className={`num text-xs font-semibold ${tone(r.change_pct)}`}>{fmtPct(r.change_pct)}</span>
        </div>
        <div className="mt-1.5 flex items-center justify-between">
          <span className="num text-[10px] text-slate-600">
            H {r.ohlc?.high?.toFixed(1) ?? "—"} · L {r.ohlc?.low?.toFixed(1) ?? "—"}
          </span>
          {r.status !== "live" && <StatusBadge status={r.status} />}
        </div>
      </button>
    ))}
    {!rows && <div className="h-[86px] w-full animate-pulse rounded-md bg-slate-900" />}
  </section>
);
